import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
class ContextAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = "TaskGo";
	controllerName = 'contexts';

	/**
	 * Lấy context theo sid khi đăng nhập vào từ amis
	 */
	async getContext(param) {
		let request = {
			url: [this.getAPIUrl()].join(''),
		};

		let res = await httpClient.getAsync(request);
		//Group cac SubsystemCode 
		for (let i = 0; i < res.Permission?.length; i++) {
			res.Permission[i].RoleApplicationDetails = res.Permission[i].RoleApplicationDetails?.reduce((result, current) => {
				const SubsystemCode = current.SubsystemCode;
				const action = current.Action;
				const isEditTrue = action.Edit === true;
				const isViewTrue = action.View === true;

				if (!result[SubsystemCode]) {
					result[SubsystemCode] = {
						SubsystemCode,
						Action: { Edit: false, View: false }
					};
				}

				if (isEditTrue) {
					result[SubsystemCode].Action.Edit = true;
				}

				if (isViewTrue) {
					result[SubsystemCode].Action.View = true;
				}
				return result;
			}, {});
		}
		return res;
	}

	async getListOrganization() {
		let request = {
			url: [this.getAPIUrl(), 'organization'].join('/'),
		};
		let res = await httpClient.getAsync(request);
		return res
	}

}

export default new ContextAPI();
